import React from "react";

import { Block } from "./dynamicPage.model";
import { PageContainer, BlockContainer } from "./DynamicPageContainers";
import { TabContainer } from "@companion-core/shared/app/Components/TabContainer";
import { isJourneyBlock } from "@companion-core/shared/app/Components/Blocks/Layouts/PostListJourneyLayout/postListJourneyLayout.utils";
import { isFullBleedBlock } from "@companion-core/shared/app/Utils/componentHelper";
import { DynamicContent } from "@companion-core/shared/app/Components/Blocks/DynamicContent";
import { useDynamicPage } from "./hooks/useDynamicPageContent";
import { DynamicPageStepper } from "./DynamicPageStepper";
import { useDynamicPageParams } from "./hooks/dynamicPageHooks";
import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import { trackDynamicPage } from "@companion-core/shared/app/tracking/dynamicPage";
import { RedirectToNotFound } from "./RedirectToNotFound/RedirectToNotFound";

const DynamicPageTracker: React.FC<{ pageSlug: string }> = ({ pageSlug }) => {
  useMountEffect(() => {
    trackDynamicPage({ pageSlug });
  });
  return null;
};

const DynamicPageContent = () => {
  const {
    lang,
    pageSlug,
    isPending,
    parsedData,
    onboardingEnabled,
    ensureContentAvailable,
    pageContainsVerticalList,
    pageUsesFillLayout,
    shouldRedirectToNotFound,
  } = useDynamicPage();

  if (shouldRedirectToNotFound) {
    return <RedirectToNotFound />;
  }

  return (
    <>
      <DynamicPageTracker key={pageSlug} pageSlug={pageSlug} />
      {ensureContentAvailable() && (
        <PageContainer
          pageContainsVerticalList={pageContainsVerticalList}
          pageUsesFillLayout={pageUsesFillLayout}>
          {!isPending &&
            parsedData &&
            parsedData.map((block: Block, index: number) => (
              <BlockContainer
                key={`block-${index}`}
                fillLayout={
                  pageContainsVerticalList ||
                  isFullBleedBlock(block.type) ||
                  (onboardingEnabled && isJourneyBlock(block.type, block.display_type ?? ""))
                }>
                {block.type === "tab-container" ? (
                  <TabContainer name={block.slug ?? ""} tabBlocks={block.subBlocks ?? []} />
                ) : (
                  <DynamicContent
                    type={block.type}
                    contentProps={{
                      id: block.id,
                      slug: block.slug,
                      lang: lang,
                      displayType: block.display_type,
                    }}
                  />
                )}
              </BlockContainer>
            ))}
        </PageContainer>
      )}
    </>
  );
};

export const DynamicPage = () => {
  const { pageSlug } = useDynamicPageParams();

  if (pageSlug === "onboarding") {
    return <DynamicPageStepper />;
  }

  return <DynamicPageContent />;
};
